module.exports = __webpack_public_path__ + "static/media/asaas.64a717a1.svg";